import React from "react";
import calendarSvg from "../icons/calenderDark.svg";
import LocationSvg from "../icons/locationDark.svg";
import TimeSvg from "../icons/time.svg";
import { dateFormater, extractTimeFromDate, formatEventDateTime, formatEventDuration, handleOffers } from "../../../utils/util";
import PaymentFailed from "./PaymentFailed";
import dateFormat from "dateformat";

function Ticket(props) {
  const { data, active, payment_status } = props;
  return (
    <div className="relative">
      <div className="text-white mb-3 text-xs">Booked on: {dateFormat(data?.bookedDate,"dd mmm yy 'at' h:MM TT" )}</div>
    <div className="ticket-card relative" style={{ backgroundColor: active ? "#fff" : "#424242",opacity: active ? "1" : ".8" }}>
      <div className="event-main-head" style={{ color: "#000" }}>{data?.evantName}</div>
      <div className="mt-2 flex gap-3">
        <img className="h-fit mt-1" src={calendarSvg} alt="" />
        <div className="date-starting" style={{ fontSize: "14px", color: "#303030" }}>
          {dateFormater(data?.bookedForDate)} 
          <br />
          
        </div>
      </div>
      {/* <div className="my-4 flex gap-3 ">
        <img className="h-fit mt-1" src={LocationSvg} alt="" />
        <div className="date-starting" style={{ fontSize: "14px", color: "#303030" }}>
          {data?.status}
        </div>
      </div> */}
     <div className="my-1 flex items-center gap-3 ">
        <img className="h-4 mt-1" src={TimeSvg} alt="" />
        <div className="date-starting" style={{ fontSize: "14px", color: "#303030" }}>
        <span >{extractTimeFromDate(data?.eventDate)}-</span> <span>{extractTimeFromDate(data?.eventTo)}</span>
        </div>
      </div>
      <div className="my-1 flex gap-3 ">
        <img className="h-fit mt-1" src={LocationSvg} alt="" />
        <div className="date-starting" style={{ fontSize: "14px", color: "#303030" }}>
          {data?.hotelName}
        </div>
      </div>
      
      <div className="mt-4 flex items-center gap-3">
      {payment_status !== 1 ? <div className="payment-status-failed ml-6" style={{opacity: active? "1": ".4"}}>Payment Failed</div>
        :   <div className="payment-status-success ml-6" style={{opacity: active? "1": ".4"}}>Confirmed</div>
    }
    {data?.internal_booking && <div className="payment-status-pending" style={{opacity: active? "1": ".4"}}>Payment pending</div>}
 
      </div>
      
      <div className="flex items-center justify-between">
        <div className="h-8 w-8 bg-[#0C0C1F] rounded-full -ml-9"></div>
        <div
          className="w-full border-t-2 border-separate border-dashed border-gray-400"
          style={{ borderColor: active ? "#CACACA" : "#5d5c5c" }}
        ></div>
        <div className="h-8 w-8  rounded-full bg-[#0C0C1F] -mr-9"></div>
      </div>
      <div className="ref-no flex flex-col items-center justify-center mb-4">
        <div>
          {data?.tickets} {data?.tickets > 1 ? "Tickets" : "Ticket"}
        </div>
        {payment_status === 1 &&<div className="flex items-center gap-3 text-sm text-black ">
          <span>Amount :</span>
          { data?.rate > 0 ?
            <div> <span>₹</span> <span>{ data?.rate}</span></div> : <span>Free</span> }
         </div>
        }
        {payment_status === 1 && <div className="mt-1">Booking ID: {data?.bookingRefNo}</div>}
      </div>
      
    </div>
    {!active && <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pt-4 text-white font-semibold text-md">Ticket Expired</div>}

    </div>
  );
}

export default Ticket;
